module.exports = __webpack_public_path__ + "media/audio18.94861b70.wav";